
<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="940px"
    width="940px"
    z-index="99999"
    :persistent="true"
    :scrollable="false"
    style="overflow: hidden;positoin:relative;"
  >
    <div class="loadWrap" v-if="loadVisible">
      <md-progress-spinner md-mode="indeterminate" :class="{ 'custom-color': true }"></md-progress-spinner>
      <p style="color:green;">正在上传</p>
    </div>

    <v-card class="window-card px-4 py-5">
      <p>修改需求</p>
      <div style="overflow:hidden;">
        <el-form ref="form" :model="form">
          <el-form-item label="需求类型">
            <el-select v-model="form.requirement_type" size="small" style="width:810px;">
              <el-option
                v-for="item in requirement_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                style="width:810px;"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="需求名称">
            <el-input v-model="form.label" size="small" style="width:810px;"></el-input>
          </el-form-item>
          <div>
            <h5>模型需求</h5>
            <el-container style="border:1px solid #ddd4d4">
              <el-aside width="200px" style="border-right:1px solid #ddd4d4;">
                <el-tree
                  :data="TreeData"
                  :show-checkbox="false"
                  node-key="_id"
                  default-expand-all
                  :expand-on-click-node="false"
                  highlight-current
                  @node-click="clickNode"
                  :current-node-key="currentId"
                  ref="tree"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span
                      :style="{
                      width: node.data.type == 'requirement' ? '110px' : '78px',
                      float:'left'
                    }"
                    >
                      <el-tooltip
                        class="box-item"
                        effect="dark"
                        :content="node.data.requirement_model_name"
                        placement="right"
                      >
                        <span
                          v-if="node.data.hasOwnProperty('type') && node.data.type == 'requirement'"
                          class="xuQiuText"
                          :style="{
                          width: node.data.type == 'requirement' ? '110px' : '78px',
                        }"
                        >{{ node.data.requirement_model_name }}</span>
                      </el-tooltip>
                      <el-tooltip
                        class="box-item"
                        effect="dark"
                        :content="node.data.label"
                        placement="right"
                      >
                        <span
                          v-if="node.data.type !== 'requirement'"
                          style="width:78px;display:inline-block;"
                          class="xuQiuText"
                        >{{ node.data.label }}</span>
                      </el-tooltip>
                    </span>
                    <span style="margin-left:5px;float:left;">
                      <i @click.stop="append(data)" class="el-icon-plus"></i>
                      <i
                        v-if="data.type !== 'requirement'"
                        @click.stop="remove(node, data)"
                        style="margin-left:5px;"
                        class="el-icon-delete"
                      ></i>
                    </span>
                  </span>
                </el-tree>
              </el-aside>
              <el-container>
                <el-main style="padding:10px 0;">
                  <!-- 模型需求部分 -->
                  <div v-if="componentShow">
                    <el-form-item label="名称">
                      <el-input
                        v-model="form.requirement_model_name"
                        size="small"
                        style="width:636px;"
                      ></el-input>
                    </el-form-item>
                    <el-form-item label="类型">
                      <el-select
                        v-model="form.requirement_device_type"
                        size="small"
                        style="width:636px;"
                        @change="changeType"
                      >
                        <el-option
                          v-for="item in requirement_device_type"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                          style="width:636px;"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="分类">
                      <el-select
                        v-model="form.requirement_modmajor_type"
                        size="small"
                        style="width:636px;"
                      >
                        <el-option
                          v-for="item in requirement_modmajor_type"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code"
                          style="width:636px;"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="尺寸">
                      <div class="sizeWrap">
                        <div style="width: 100px">
                          <el-button @click="addSize" size="mini">
                            <i class="el-icon-plus"></i>
                          </el-button>
                        </div>
                        <div v-for="item in TreeData[0].requirement_size" :key="item._id">
                          <el-input
                            type="text"
                            v-model="item.label"
                            placeholder="长"
                            style="width: 120px; margin-right: 10px"
                            size="small"
                          ></el-input>
                          <el-input
                            v-model="item.value"
                            style="width: 278px"
                            type="text"
                            size="small"
                          ></el-input>
                          <el-button
                            @click="removeSize(item)"
                            size="small"
                            style="padding:8px 7px;"
                          >
                            <i class="el-icon-minus"></i>
                          </el-button>
                          <!-- <el-button type="primary" :icon="Edit" /> -->
                        </div>
                      </div>
                      <div class="cadWrap">
                        <div style="display: inline-block">
                          <el-upload
                            action="#"
                            :show-file-list="true"
                            :limit="2"
                            :file-list="TreeData[0].requirement_cad"
                            :http-request="
                          params => httpRequest(params, 'requirement_cad')
                        "
                            class="upload-demoCad"
                            list-type="text"
                            :before-remove="
                          file => fujianRemove(file, 'requirement_cad')
                        "
                            :on-exceed="handlecad"
                            accept=".dwg, .dxf, .dwt, .dws, .png, .jpg, .gif, .svg"
                          >
                            <el-tooltip
                              class="item"
                              effect="dark"
                              content="请上传dwg、dxf、dwt、dws、png、jpg、gif、svg其中一种格式"
                              placement="top-start"
                            >
                              <el-button>
                                <el-icon style="font-size: 19px">
                                  <Upload />
                                </el-icon>尺寸图上传
                              </el-button>
                            </el-tooltip>
                          </el-upload>
                        </div>
                      </div>
                    </el-form-item>
                    <!-- 图片及视频 -->
                    <div style="width: 635px; transform: translateX(5px)">
                      <p>图片及视频</p>
                      <div id="pubUpload" class="imgVideoWrap">
                        <!-- 图片及视频 -->
                        <el-upload
                          action="#"
                          :file-list="
                        TreeData[0].requirement_imagevideo_list
                      "
                          :http-request="
                        params =>
                          httpRequest(params, 'requirement_imagevideo_list')
                      "
                          accept="jpg, png, gif, svg, mp4"
                          list-type="picture-card"
                          style="margin-bottom: 0px"
                          :on-remove="handleRemove"
                          multiple
                        >
                          <template #file="{ file }">
                            <div class="mengbanWrap">
                              <!-- <span style="position:absolute;top:0px;z-index:99999, width:100px; background-color: red; height:20px;">{{file}}</span> -->
                              <div class="mengban">
                                <div class="videoDel">
                                  <i
                                    class="el-icon-search"
                                    @click="handlePictureCardPreview(file)"
                                    style="font-size: 20px; color: #fff;float:left;"
                                  ></i>

                                  <a
                                    :href="file.url"
                                    class="el-icon-download"
                                    style="margin-left: 10px; display:inline-block;font-size: 20px; color: #fff;float:left;"
                                  >
                                    <!-- <i class="el-icon-download"></i> -->
                                  </a>

                                  <i
                                    class="el-icon-delete"
                                    @click="delimgvideo(file, 'requirement_imagevideo_list')"
                                    style="
                                  font-size: 20px;
                                  color: #fff;
                                  margin-left: 10px;
                                  float:left;
                                "
                                  ></i>
                                </div>
                              </div>

                              <img
                                v-if="
                              file.url.lastIndexOf('jpg') !== -1 ||
                              file.url.lastIndexOf('png') !== -1 ||
                              file.url.lastIndexOf('gif') !== -1 ||
                              file.url.lastIndexOf('jpeg') !== -1
                            "
                                class="imgvideo"
                                :src="file.url"
                                alt
                              />

                              <video
                                v-if="file.url.lastIndexOf('mp4') !== -1"
                                :src="file.url"
                                class="imgvideo"
                                :autoplay="false"
                                controls="controls"
                                muted
                              ></video>
                            </div>
                          </template>
                          <el-icon>
                            <Plus />
                          </el-icon>
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                    <!-- 附件 -->
                    <el-form-item>
                      <div style="display: inline-block; margin-top: 10px">
                        <el-upload
                          action="#"
                          :show-file-list="true"
                          :limit="3"
                          :file-list="TreeData[0].requirement_annex"
                          :http-request="
                        file => httpRequest(file, 'requirement_annex')
                      "
                          :on-exceed="handleannex"
                          class="upload-demoCad"
                          list-type="text"
                          :on-preview="handlePictureCardPreview"
                          :before-remove="
                        file => fujianRemove(file, 'requirement_annex')
                      "
                        >
                          <el-button>
                            <el-icon style="font-size: 19px">
                              <Upload />
                            </el-icon>附件
                          </el-button>
                        </el-upload>
                      </div>
                    </el-form-item>
                    <el-form-item label="描述">
                      <el-input
                        v-model="TreeData[0].requirement_des"
                        :autosize="{ minRows: 5 }"
                        type="textarea"
            
                        placeholder="请输入需求描述"
                      ></el-input>
                    </el-form-item>
                  </div>
                  <!-- 模型需求部分 -->
                  <div v-else>
                    <el-form-item label="名称">
                      <el-input v-model="checkNode.label" size="small" style="width:636px;"></el-input>
                    </el-form-item>
                    <el-form-item label="描述">
                      <el-input
                        v-model="checkNode.component_des"
                        :autosize="{ minRows: 5 }"
                        type="textarea"
                        style="width: 636px"
                        placeholder="请输入部件描述"
                      ></el-input>
                    </el-form-item>

                    <!-- 图片及视频 -->
                    <div style="width: 635px; transform: translateX(5px)">
                      <p>图片及视频</p>
                      <div id="pubUpload" class="imgVideoWrap">
                        <!-- 图片及视频 -->
                        <el-upload
                          action="#"
                          :file-list="
                        checkNode.component_imgvideo_list
                      "
                          :http-request="
                        params =>
                          httpRequest(params, 'component_imgvideo_list')
                      "
                          accept="jpg, png, gif, svg, mp4"
                          list-type="picture-card"
                          style="margin-bottom: 0px"
                          :on-remove="handleRemove"
                        >
                          <template #file="{ file }">
                            <div class="mengbanWrap">
                              <!-- <span style="position:absolute;top:0px;z-index:99999, width:100px; background-color: red; height:20px;">{{file}}</span> -->
                              <div class="mengban">
                                <div class="videoDel">
                                  <i
                                    class="el-icon-search"
                                    @click="handlePictureCardPreview(file)"
                                    style="font-size: 20px; color: #fff;float:left;"
                                  ></i>

                                  <a
                                    :href="file.url"
                                    class="el-icon-download"
                                    style="margin-left: 10px; display:inline-block;font-size: 20px; color: #fff;float:left;"
                                  >
                                    <!-- <i class="el-icon-download"></i> -->
                                  </a>

                                  <i
                                    class="el-icon-delete"
                                    @click="delimgvideo(file, 'component_imgvideo_list')"
                                    style="
                                  font-size: 20px;
                                  color: #fff;
                                  margin-left: 10px;
                                  float:left;
                                "
                                  ></i>
                                </div>
                              </div>

                              <img
                                v-if="
                              file.url.lastIndexOf('jpg') !== -1 ||
                              file.url.lastIndexOf('png') !== -1 ||
                              file.url.lastIndexOf('gif') !== -1 ||
                              file.url.lastIndexOf('jpeg') !== -1
                            "
                                class="imgvideo"
                                :src="file.url"
                                alt
                              />

                              <video
                                v-if="file.url.lastIndexOf('mp4') !== -1"
                                :src="file.url"
                                class="imgvideo"
                                :autoplay="false"
                                controls="controls"
                                muted
                              ></video>
                            </div>
                          </template>
                          <!-- <el-icon>
                            <Plus />
                          </el-icon>-->
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                    <!-- 附件 -->
                    <el-form-item label="附件">
                      <div style="display: inline-block; margin-top: 10px">
                        <el-upload
                          action="#"
                          :show-file-list="true"
                          :limit="3"
                          :file-list="checkNode.component_annex_list"
                          :http-request="
                        file => httpRequest(file, 'component_annex_list')
                      "
                          :on-exceed="handleannex"
                          class="upload-demoCad"
                          list-type="text"
                          :on-preview="handlePictureCardPreview"
                          :before-remove="
                        file => fujianRemove(file, 'component_annex_list')
                      "
                        >
                          <el-button>
                            <el-icon style="font-size: 19px">
                              <Upload />
                            </el-icon>附件
                          </el-button>
                        </el-upload>
                      </div>
                    </el-form-item>
                  </div>
                  <!-- 模型部分 -->
                  <!-- 模型部分 -->

                  <div>
                    <h4>动画需求</h4>
                    <div class="animationWrap">
                      <div style="overflow: hidden; min-height: 50px">
                        <el-button @click="addAnimation" style="transform: translate(10px, 10px)">
                          <i class="el-icon-plus"></i>
                        </el-button>

                        <div style="overflow: hidden">
                          <div
                            v-for="(item, idx) in TreeData[0].requirement_animation"
                            :key="item._id"
                            style="
                              border: 1px dashed gray;
                              margin: 20px auto;
                              width: 670px;
                              height:auto;
                   
                              padding-left: 5px;
                              position: relative;
                            "
                          >
                            <span
                              style="
                                color: red;
                                position: absolute;
                                top: -11px;
                                background-color: #fff;
                              "
                            >动画{{ idx + 1 }}</span>
                            <div style="overflow: hidden">
                              <div style="overflow: hidden; margin-top: 10px">
                                <p
                                  style=" margin-right: 10px; margin-left: 5px;margin-bottom:5px;"
                                >名称</p>
                                <el-input
                                  v-model="item.animation_name"
                                  placeholder="请输入动画名称"
                                  style="width: 590px; float: left"
                                ></el-input>
                                <el-button
                                  @click="delAnimation(item)"
                                  style="transform: translatex(10px); float: left"
                                >
                                  <i class="el-icon-delete"></i>
                                </el-button>
                              </div>
                              <div style="overflow: hidden">
                                <p style="float: left; margin-right: 10px; margin-left: 5px">描述</p>
                                <div style="overflow: hidden; float: left">


                                <Toolbar
                                style="border-bottom: 1px solid #ccc;width:630px;"
                                :editor="editor"
                                :defaultConfig="toolbarConfig"
                                :mode="mode"
                                />
                                <Editor
                                style="height: auto; min-height:200px;width:630px;"
                                v-model="item.animation_des"
                                :defaultConfig="editorConfig"
                                :mode="mode"
                                @onCreated="onCreated"
                                />
                                </div>
                              </div>
                            </div>

                            <div
                              style="
                                margin-top: 8px;
                                width: 820px;
                                overflow: hidden;
                            
                              "
                            >
                              <!-- border: 1px solid #ddd4d4; -->
                              <p>图片及视频</p>
                              <div style="float: left; float: left">
                                <div id="pubUpload" class="imgVideoWrapcom">
                                  <el-upload
                                    action="#"
                                    :file-list="item.animation_imagevideo_list"
                                    :http-request="
                                      params =>
                                        httpRequest(
                                          params,
                                          'animation_imagevideo_list',
                                          idx
                                        )
                                    "
                                    accept="jpg, png, gif, svg, mp4"
                                    list-type="picture-card"
                                    style="margin-bottom: 0px"
                                    :on-remove="handleRemove"
                                  >
                                    <template #file="{ file }">
                                      <div class="mengbanWrap">
                                        <div class="mengban">
                                          <div class="videoDel">
                                            <i
                                              class="el-icon-search"
                                              @click="handlePictureCardPreview(file)"
                                              style="font-size: 20px; color: #fff;float:left;"
                                            ></i>

                                            <a
                                              :href="file.url"
                                              class="el-icon-download"
                                              style="margin-left: 10px; display:inline-block;font-size: 20px; color: #fff;float:left;"
                                            >
                                              <!-- <i class="el-icon-download"></i> -->
                                            </a>

                                            <i
                                              class="el-icon-delete"
                                              @click="delimgvideo(file, 'animation_imagevideo_list',idx)"
                                              style="
                                          font-size: 20px;
                                          color: #fff;
                                          margin-left: 10px;
                                          float:left;
                                        "
                                            ></i>
                                          </div>
                                        </div>
                                        <img
                                          v-if="
                                            file.url.lastIndexOf('jpg') !== -1 ||
                                            file.url.lastIndexOf('png') !== -1 ||
                                            file.url.lastIndexOf('gif') !== -1 ||
                                            file.url.lastIndexOf('jpeg') !== -1
                                          "
                                          class="imgvideo"
                                          :src="file.url"
                                          alt
                                        />

                                        <video
                                          v-if="file.url.lastIndexOf('mp4') !== -1"
                                          :src="file.url"
                                          class="imgvideo"
                                          :autoplay="false"
                                          controls="controls"
                                          muted
                                        ></video>
                                      </div>
                                    </template>
                                    <i class="el-icon-plus"></i>
                                  </el-upload>
                                </div>
                              </div>

                              <div class="animationImgWrap">
                                <div style="display: inline-block; float: left">
                                  <el-upload
                                    action="#"
                                    :show-file-list="true"
                                    :limit="3"
                                    :file-list="item.animation_annex_list"
                                    :http-request="
                                    file => httpRequest(file, 'animation_annex_list', idx)
                                  "
                                    :on-exceed="handleannex"
                                    class="upload-demoCad"
                                    list-type="text"
                                    :on-preview="handlePictureCardPreview"
                                    :before-remove="
                                    file => fujianRemove(file, 'animation_annex_list', idx)
                                  "
                                  >
                                    <el-button>
                                      <el-icon style="font-size: 19px">
                                        <Upload />
                                      </el-icon>附件
                                    </el-button>
                                  </el-upload>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-main>
              </el-container>
            </el-container>
          </div>
        </el-form>
      </div>
      <v-card-actions>
        <p class="dialog-footer">
          <v-btn @click="cancel">取 消</v-btn>
          <v-btn type="primary" style="margin-left: 10px;" @click="submit">确 定</v-btn>
        </p>
      </v-card-actions>
    </v-card>
    <el-dialog
      title="提示"
      :visible.sync="privewImageVisible"
      close-on-click-modal
      width="650px"
      append-to-body
    >
      <div style="width: 600px; height: 600px;padding:10px;">
        <img
          v-if="
          privewImageUrl.lastIndexOf('jpg') !== -1 ||
          privewImageUrl.lastIndexOf('png') !== -1 ||
          privewImageUrl.lastIndexOf('gif') !== -1 ||
          privewImageUrl.lastIndexOf('jpeg') !== -1
        "
          style="width: 100%; height: 100%"
          :src="privewImageUrl"
          alt
        />

        <video
          controls
          muted
          id="prevideo"
          v-if="privewImageUrl.lastIndexOf('mp4') !== -1"
          style="width: 100%; height: 100%"
        >
          <source :src="privewImageUrl" type="video/mp4" />
          <source :src="privewImageUrl" type="video/ogg" />您的浏览器不支持 video 标签。
        </video>
      </div>
    </el-dialog>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import { extend } from 'vee-validate';
import { required, required_if } from 'vee-validate/dist/rules';
import { upload, ossUpload, getossUploadToken } from '@/api/user';
import Oss from 'ali-oss';

import { resetModelResource } from '@/api/model_resource';
import Dropzone from 'dropzone';
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
extend('required', required);
extend('required_if', required_if);

export default {
  components:{
    Editor, Toolbar
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    showNewDialog: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    loadVisible:false,
    //树结构
    TreeData: [],
    //需求类型
    requirement_type: [
      {
        Id: 1,
        label: '模型以及动画',
        value: 'modelAnimation',
      },
      {
        Id: 1,
        label: '视频',
        value: 'video',
      },
    ],
    //类型
    requirement_device_type: [
      {
        id: 1,
        label: '设备',
        value: 'device',
      },
      {
        id: 2,
        label: '角色',
        value: 'role',
      },
      {
        id: 3,
        label: '工具',
        value: 'tool',
      },
      {
        id: 4,
        label: '场景',
        value: 'scene',
      },
    ],
    //分类
    requirement_modmajor_type: [],
    componentShow: true,
    privewImageUrl: '',
    privewImageVisible: false,
    checkNode: {},
    currentId: null,
        editor: null,
    html: '<p>hello</p>',
    toolbarConfig: { },
    editorConfig: { placeholder: '请输入内容...' },
    mode: 'default', // or 'simple'
  }),
  watch: {
    privewImageVisible(news) {
      if (news) {
        this.$nextTick(() => {
          if (this.privewImageUrl.lastIndexOf('.mp4') !== -1) {
            let videoDom = document.getElementById('prevideo');
            videoDom.play();
            videoDom.muted = false;
          }
        });
      } else {
        if (this.privewImageUrl.lastIndexOf('.mp4') !== -1) {
          let videoDom = document.getElementById('prevideo');
          this.privewImageUrl = '';
          videoDom.pause();
          videoDom.muted = true;
        }
      }
    },
  },
  methods: {
    onCreated(editor) {
    this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    // console.log(this.editor)
    // this.editorRef =  editor
      // editor.disable()

    },
    addAnimation() {
      this.TreeData[0].requirement_animation.push({
        _id: this.uuid(),
        animation_des: '',
        animation_imagevideo_list: [],
        animation_annex_list: [],
      });
    },
    //删除动画
    delAnimation(data) {
      this.$confirm(`确认删除当前${data.animation_name ? data.animation_name : ''}的动画？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.TreeData[0].requirement_animation = this.TreeData[0].requirement_animation.filter(
            item => item._id !== data._id
          );
          return true;
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
          return false;
        });
      return false;
    },
    // 添加节点
    append(data) {
      const newChild = {
        _id: this.uuid(),
        label: '子部件' + parseInt(data.children.length + 1), //部件名称
        component_des: '',
        component_imgvideo_list: [],
        component_annex_list: [],
        children: [],
      };
      if (!data.children) {
        data.children = [];
      }
      data.children.push(newChild);
    },
    //删除节点
    remove(node, data) {
      this.$confirm(`确认删除当前名称为${data.label}的部件？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          const parent = node.parent;
          const children = parent.data.children || parent.data;
          const index = children.findIndex(d => d._id === data._id);
          children.splice(index, 1);
          return true;
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
          return false;
        });
      return false;
    },
    handlePictureCardPreview(uploadFile) {
      // console.log(uploadFile.url);
      this.privewImageUrl = uploadFile.url;
      this.privewImageVisible = true;
    },
    //添加尺寸
    addSize() {
      this.TreeData[0].requirement_size.push({
        _id: this.uuid(),
        label: '',
        value: '',
      });
    },
    //删除尺寸
    removeSize(data) {
      this.TreeData[0].requirement_size = this.TreeData[0].requirement_size.filter(
        item => item._id !== data._id
      );
    },
    cancel() {
      this.$emit('closeDialog');
    },
    changeType(value) {
      this.$dic.getCategoryList(
        {
          cate_type: value || '',
          level: '1',
        },
        res => {
          this.requirement_modmajor_type = res;
        }
      );
    },
    //点击节点
    clickNode(node) {
      if (node.type && node.type == 'requirement') {
        this.componentShow = true;
      } else {
        this.componentShow = false;
        this.checkNode = node;
      }
    },
    handleRemove(file) {
      console.log(file);
    },

    //删除图片提示
    delimgvideo(file, type, idx) {
      this.$confirm(`确认删除当前名称为${file.name}的资源？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (type == 'requirement_imagevideo_list') {
            this.TreeData[0].requirement_imagevideo_list =
              this.TreeData[0].requirement_imagevideo_list.filter(item => item._id !== file._id);
          } else if (type == 'component_imgvideo_list') {
            this.checkNode.component_imgvideo_list = this.checkNode.component_imgvideo_list.filter(
              item => {
                return item._id !== file._id;
              }
            );
          } else if (type == 'animation_imagevideo_list') {
            console.log(idx);
            this.TreeData[0].requirement_animation[idx].animation_imagevideo_list =
              this.TreeData[0].requirement_animation[idx].animation_imagevideo_list.filter(item => {
                return item._id !== file._id;
              });
            // this.TreeData[0].requirement_imagevideo_list = this.TreeData[0].requirement_imagevideo_list.filter(item => item._id !== file._id);
          }

          // } else if (type == 'animation_annex_list') {
          //   TreeData[0].requirement_animation.forEach(item => {
          //     item.animation_annex_list = item.animation_annex_list.filter(items => {
          //       return items.uid != file.uid;
          //     });
          //   });
          // } else if (type == 'component_imgvideo_list') {
          //   //子部件图片请求ui
          //  this.checkNode.component_imgvideo_list =
          //     this.checkNode.component_imgvideo_list.filter(item => {
          //       return item._id !== file._id;
          //     });

          //   return true;
          // } else {
          //   this.TreeData[0].requirement_imagevideo_list =
          //     this.TreeData[0].requirement_imagevideo_list.filter(item => item._id !== file._id);
          // }

          return true;
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
          return false;
        });
      return false;
      // ElMessageBox.confirm(`确认删除当前名称为${file.name}的资源？`, {
      //   confirmButtonText: '确认',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // })
      //   .then(() => {
      //     if (type == 'animation_imagevideo_list') {
      //       TreeData[0].requirement_animation.forEach(item => {
      //         item.animation_imagevideo_list =
      //           item.animation_imagevideo_list.filter(items => {
      //             return items.uid != file.uid;
      //           });
      //       });
      //     } else if (type == 'animation_annex_list') {
      //       TreeData[0].requirement_animation.forEach(item => {
      //         item.animation_annex_list = item.animation_annex_list.filter(
      //           items => {
      //             return items.uid != file.uid;
      //           }
      //         );
      //       });
      //     } else if (type == 'component_imgvideo_list') {
      //       //子部件图片请求ui
      //       typeArr.checkNode.component_imgvideo_list =
      //         typeArr.checkNode.component_imgvideo_list.filter(item => {
      //           return item._id !== file._id;
      //         });

      //       return true;
      //     } else {
      //       TreeData[0].requirement_imagevideo_list =
      //         TreeData[0].requirement_imagevideo_list.filter(
      //           item => item._id !== file._id
      //         );
      //     }

      //     return true;
      //   })
      //   .catch(() => {
      //     ElMessage({
      //       type: 'info',
      //       message: '取消删除',
      //     });
      //     return false;
      //   });
      // return false;
    },
    fujianRemove(file, type, idx) {
      this.$confirm(`确认删除当前名称为${file.name}的文件？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          // requirement_cad
          // requirement_annex
          // animation_annex_list
          // component_annex_list
          console.log(file);
          console.log(type);
          console.log(idx);

          if (type == 'requirement_cad') {
            this.TreeData[0].requirement_cad = this.TreeData[0].requirement_cad.filter(
              item => item._id !== file._id
            );
          }
          if (type == 'requirement_annex') {
            this.TreeData[0].requirement_annex = this.TreeData[0].requirement_annex.filter(
              item => item._id !== file._id
            );
          }

          if (type == 'component_annex_list') {
            this.checkNode.component_annex_list = this.checkNode.component_annex_list.filter(
              item => item._id !== file._id
            );
          }
          if (type == 'animation_annex_list') {
            this.TreeData[0].requirement_animation[idx]['animation_annex_list'] =
              this.TreeData[0].requirement_animation[idx]['animation_annex_list'].filter(
                item => item._id !== file._id
              );
          }

          /* if (type == 'animation_annex_list') {
            this.TreeData[0].requirement_animation[idx].animation_annex_list =
              this.TreeData[0].requirement_animation[idx].animation_annex_list.filter(
                item => item._id !== file._id
              );
          }
          */

          return true;
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
          return false;
        });
      return false;
    },
    //请求图片视频附件
    httpRequest(param, filePropertyType = 'requirement_imagevideo_list', idx = 0) {
      this.loadVisible = true;
      getossUploadToken({})
        .then(result => {
          const creditInfo = result.data;
          const aliOss = new Oss(creditInfo);
          aliOss
            .put(`${filePropertyType}/${new Date().getTime()}/${param.file.name}`, param.file, {
              headers: {
                'Access-Control-Allow-Origin': '*',
              },
            })
            .then(res => {
              this.setqueryImgUrl(param.file, res.url, filePropertyType, idx);
            });
        })
        .catch(err => {
            this.loadVisible = false;
          console.log(err);
        });
    },
    /**
     * 生成uuid
     */
    uuid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    setqueryImgUrl(file, url, type, idx) {
      let obj = {
        _id: this.uuid(),
        name: file.name,
        url,
        type: type,
      };
      if (
        type == 'requirement_imagevideo_list' ||
        type == 'requirement_cad' ||
        type == 'requirement_annex'
      ) {
        this.TreeData[0][type].push(JSON.parse(JSON.stringify(obj)));
      } else if (type == 'component_imgvideo_list') {
        this.checkNode.component_imgvideo_list.push(JSON.parse(JSON.stringify(obj)));
      } else if (type == 'animation_imagevideo_list') {
        this.TreeData[0].requirement_animation[idx]['animation_imagevideo_list'].push(
          JSON.parse(JSON.stringify(obj))
        );
      } else if (type == 'animation_annex_list') {
        this.TreeData[0].requirement_animation[idx]['animation_annex_list'].push(
          JSON.parse(JSON.stringify(obj))
        );
      } else if (type == 'component_annex_list') {
        this.checkNode.component_annex_list.push(JSON.parse(JSON.stringify(obj)));
      }
            this.loadVisible = false;
    },
    handleannex(files, type) {
      ElMessage({
        message: `附件最多上传3张`,
        type: 'warning',
      });
    },
    handlecad(files, type) {
      this.$message({
        showClose: true,
        message: 'CAD最多上传2张',
        type: 'warning',
      });
    },
    async submit() {
      let form = { ...this.TreeData[0] };
      if (form.status == 8) {
        form.status = 8;
      } else if (form.status == 10) {
        form.status = 8;
      } else if (form.status == 9) {
        form.status = 9;
      }

      await resetModelResource(form)
        .then(res => {
          if (res.code === '200') {
            this.$notify({
              timeout: 1500,
              message: '提交成功！',
              icon: 'add_alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'success',
            });
            this.$emit('closeDialog', res.data);
          } else {
            this.$notify({
              timeout: 1500,
              message: '提交成功！',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning',
            });
          }
          // this.form = initForm();
        })

        .finally(_ => {
          this.uploadProgress = '';
          this.overlay = false;
        });
    },

    // async submit() {
    //   //判断是修改还是重新提交需求
    //   if (status == 8) {
    //     form.status = 8;
    //   } else if (status == 10) {
    //     form.status = 8;
    //   } else if (status == 9) {
    //     form.status = 9;
    //   }

    //   await resetModelResource(form)
    //     .then(res => {
    //       if (res.code === '200') {
    //         this.$notify({
    //           timeout: 1500,
    //           message: '提交成功！',
    //           icon: 'add_alert',
    //           horizontalAlign: 'center',
    //           verticalAlign: 'bottom',
    //           type: 'success',
    //         });
    //         this.$emit('closeDialog', res.data);
    //       } else {
    //         this.$notify({
    //           timeout: 1500,
    //           message: '提交成功！',
    //           horizontalAlign: 'center',
    //           verticalAlign: 'bottom',
    //           type: 'warning',
    //         });
    //       }
    //       // this.form = initForm();
    //     })

    //     .finally(_ => {
    //       this.uploadProgress = '';
    //       this.overlay = false;
    //     });
    // },
  },
  created() {
    if (this.form.requirement_device_type) {
      this.changeType(this.form.requirement_device_type);
    }
    // this.formData.modelType = this.form.model_type;
    // this.formData.modelDeviceType = this.form.model_device_type;
    // this.formData.modelName = this.form.model_name;
    // this.formData.modelLong = this.form.model_long;
    // this.formData.modelWidth = this.form.model_width;
    // this.formData.modelHeight = this.form.model_Height;
    // this.formData.taskId = this.form.taskId;
    // this.formData.nodeId = this.form.nodeId;
    // this.formData.tag = this.form.tag;
    // this.formData.status = this.form.status;
    // // this.formData.modelCadList = this.form.model_cad_list;
    // this.formData.modelRequirement = this.form.model_requirement;
    // this.formData.modelImageList = this.form.model_image_list;
    // this.formData.modelVideoList = this.form.model_video_list;
    // this.formData.modelAnnexList = this.form.model_annex_list;
    // this.formData.modelSubassemblyList = this.form.model_subassembly_list;
    // this.formData.animationVideoList = this.form.animation_video_list;
    // this.formData.animationDes = this.form.animation_des;
    // this.formData._id = this.form._id;

    this.TreeData.push(this.form);

    this.$nextTick(() => {
      this.currentId = this.form._id;
      this.$refs.tree.setCurrentKey(this.currentId);
    });
  },
  mounted() {
    // this.initDict('device');
  },
  destroyed() {},
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
  }
};
</script>

<style scoped>
.pubWrap {
  margin: 10px 0;
}

/deep/ #pubUpload .el-upload,
.el-upload--picture-card {
  width: 114px;
  height: 114px;
  line-height: 114px;
}
/deep/ #pubUpload .el-upload-list {
  padding-left: 0px;
}
.uploadImg {
  width: 114px;
  height: 114px;
  line-height: 114px !important;
}

/deep/ #pubUpload .el-upload-list__item,
.is-ready {
  width: 114px;
  height: 114px;
  line-height: 114px;
}
.animation {
  margin-top: 20px;
}

.items {
  width: auto;
  margin: 20px 10px 0px;
  padding: 10px 10px 10px;
  border: 1px solid #d3d0d0;
  border-radius: 5px;
  position: relative;
}

.itemTitle {
  width: 50px;
  position: absolute;
  top: -10px;
  background: #fff;
  height: 20px;
  left: 20px;
  font-size: 12px;
  text-align: center;
  margin: auto;
  color: red;
}

.dialog-footer {
  width: 100%;
  margin-top: 10px;
  text-align: right;
}

.conpub {
  float: left;
}

.leftTreeWrap {
  height: auto;
  padding: 10px 10px;
  width: 180px;
  background: red;
}

.rightConWrap {
  width: 525px;
  height: 600px;
}
.cadWrap {
  border: 1px solid #e1e1e1;
  min-height: 162px;
  width: 150px;
  float: left;
}

/deep/ .cadWrap .el-upload-list .el-upload-list__item {
  width: 125px;
}

.sizeWrap {
  border: 1px solid #e1e1e1;
  float: left;
  width: 480px;
}

:deep(#pubUpload .el-upload, .el-upload--picture-card) {
  width: 115px;
  height: 115px;
}
.uploadImg {
  width: 115px;
  height: 115px;
}

:deep(#pubUpload .el-upload-list__item, .is-ready) {
  width: 115px;
  height: 115px;
}

.imgVideoWrap {
  border: 1px dashed #ddd4d4;
  width: 670px;
}
.imgVideoWrapcom {
  border: 1px dashed #ddd4d4;
  width: 655px;
}

.mengbanWrap {
  position: relative;
  width: 115px;
  height: 115px;
  cursor: pointer;
}
.mengbanWrap :hover.mengban {
  opacity: 1;
}
.mengban {
  width: 115px;
  height: 115px;
  background: #373636a8;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 999;
  opacity: 0;
}

.imgvideo {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 115px;
  height: 115px;
}
:deep(.el-form-item__content) {
  align-items: start;
}

.videoDel {
  position: absolute;
  right: 0;
  top: 50px;
  left: 0;
  width: 90px;
  margin: auto;
  height: 25px;
  z-index: 99999;
  cursor: pointer;
}

.delOrAdd {
  font-size: 19px;
}
.xuQiuText {
  display: inline-block;
  font-size: 16px;
  /* width: 100px; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.animationImgWrap {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.loadWrap {
  height: 89px;
  width: 65px;
  z-index: 99999;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

/deep/.md-progress-spinner-draw .md-progress-spinner-circle{
    stroke: #21e021 !important; /* 这里将进度条的颜色设置为红色 */
}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
